import React, { Component } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

class InitiateTransferDialog extends Component {

  handleCancel = (event) => {
    if (this.props.onCancel) {
      this.props.onCancel(event);
    }
    this.props.onClose(event);
  };

  handleOk = (event) => {
    if (this.props.onConfirm) {
      this.props.onConfirm(event);
    }
    this.props.onClose(event);
  };

  handleEdit = (event) => {
    if (this.props.onEdit) {
      this.props.onEdit(event);
    }
    this.props.onClose(event);

  }

  render() {

    return (
      <Dialog
        disableEscapeKeyDown
        open={(!this.props.open ? false : this.props.open)}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            this.props.onClose()
          }
        }}
        maxWidth="xs"
        fullWidth={true}
      >
        <DialogTitle id="confirmation-dialog-title">{this.props.title}</DialogTitle>
        <DialogContent>
          {this.props.children}
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCancel} color="primary" variant="outlined">
            {this.props.cancelBtn || 'Cancel'}
          </Button>
          {this.props.editBtn &&
            <Button onClick={this.handleEdit} color="primary" variant="outlined">
              Edit
            </Button>
          }
          <Button onClick={this.handleOk} color="primary" variant="contained" disabled={this.props.okDisabled}>
            {this.props.okBtn || 'Ok'}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default InitiateTransferDialog;